import styles from "../../../assets/css/popups/addinvoicepopup.module.css";
import BackBtn from "../../backbtn";
import { JSFunctions } from "../../../App";
import { useDispatch, useSelector } from "react-redux";
import Toasts from "../../../assets/toasts/toasts";
import { useState } from "react";
import { Toaster } from "react-hot-toast";
import Overlay from "../../overlay";

function EditDataPopup(props) {
  const [data, setData] = useState({
    name: "",
    raised_date: "",
    salary: ""
  });
  const [overlay, setOverlayState] = useState(false);

  let state = useSelector((state) => state);
  const dispatch = useDispatch();
  const Toast = new Toasts();

  function cancle() {
    console.log(props);
    dispatch({ type: "", payload: { editDataWidgetState: false } });
  }
  async function edit(){
      if (data.name.length === 0 || data.raised_date.length === 0 || data.salary.length === 0) {
        Toast.error("يجب إدخال البيانات أولا")
      } else {
        let functions = new JSFunctions();
        setOverlayState(true);
        data["old_name"] = props.selectedEmployeeName
        let res = await functions.editEmployeeData(data);
        setOverlayState(false);
        if (!res) {
            Toast.error("حدث خطأ.");
        } else {
            Toast.success("تم تعديل المعلومات")
        }
      }
  }

  return (
    <>
      <div className={styles["popup"]}>
        <div className={styles.header}>
          <h2 className={styles["title"]}>تعديل معلومات  ({props.selectedEmployeeName})</h2>
          <div onClick={() => cancle("editDataWidgetState")}>
            <BackBtn />
          </div>
        </div>
        <div className={styles["gp"]}>
          <input
            className={styles["pop-up-input"]}
            value={data.name}
            onChange={(ele) => {
              setData({ ...data, name: ele.target.value });
            }}
            placeholder="الإسم الجديد"
          ></input>
        </div>
        <div className={styles["gp"]}>
          <input
            className={styles["pop-up-input"]}
            value={data.salary}
            type="number"
            onChange={(ele) => {
              setData({ ...data, salary: ele.target.value });
            }}
            placeholder="المرتب"
          ></input>
                    <input
            className={styles["pop-up-input"]}
            value={data.raised_date}
            type="number"

            onChange={(ele) => {
              setData({ ...data, raised_date: ele.target.value });
            }}
            placeholder="معاد تسليم الراتب (يوم)"
          ></input>
        </div>
      <button onClick={edit}>حفظ</button>

      </div>
      <Toaster position="top-left" reverseOrder={false} />
      {overlay ? <Overlay></Overlay> : null}
    </>
  );
}

export default EditDataPopup;
